export const educationData = [
    {
        id: 1,
        institution: 'Noida Institute of Engineering and Technology',
        course: 'Bachelor of Technology',
        startYear: '2019',
        endYear: '2023'
    },
    {
        id: 2,
        institution: 'Kendriya Vidyalaya, Delhi',
        course: '12th Grade',
        startYear: '2018',
        endYear: '2019'
    },
    {
        id: 3,
        institution: 'Kendriya Vidyalaya, UP',
        course: '10th Grade',
        startYear: '2016',
        endYear: '2017'
    },
]